"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.deleteAllStorage = deleteAllStorage;
exports.deleteCookie = deleteCookie;
exports.deleteLocalStorage = deleteLocalStorage;
exports.deleteSessionStorage = deleteSessionStorage;
exports.getAllStorage = getAllStorage;
exports.getCookie = getCookie;
exports.getLocalStorage = getLocalStorage;
exports.getSessionStorage = getSessionStorage;
exports.setAllStorage = setAllStorage;
exports.setCookie = setCookie;
exports.setLocalStorage = setLocalStorage;
exports.setSessionStorage = setSessionStorage;
require("core-js/modules/es.array.concat.js");
var LOCAL_STORAGE_SUPPORT = Boolean(typeof window !== 'undefined' && window.localStorage);
var SESSION_STORAGE_SUPPORT = Boolean(typeof window !== 'undefined' && window.sessionStorage);

/**
 * set a cookie
 *
 * @param key - cookie key
 * @param value - cookie value
 * @param durationDays - expiration date
 */
function setCookie(key, value, durationDays) {
  var cookieString = "".concat(key, "=").concat(value);
  if (durationDays) {
    var d = new Date();
    d.setTime(d.getTime() + durationDays * 24 * 3600 * 1000);
    cookieString += "; expires=".concat(d.toUTCString());
  }
  document.cookie = "".concat(cookieString, "; path=/");
}

/**
 * get a cookie
 */
function getCookie(key) {
  var name = "".concat(key, "=");
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i += 1) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

/**
 * delete a cookie
 *
 * @param key - name of cookie
 */
function deleteCookie(key) {
  setCookie(key, '', -1);
}

/**
 * get a value from localStorage
 *
 * @param key - name of property to retrieve
 */
function getLocalStorage(key) {
  if (LOCAL_STORAGE_SUPPORT) {
    return window.localStorage.getItem(key);
  }
  return getCookie(key);
}

/**
 * set a value in localStorage
 *
 * @param key - name of property
 * @param value - value of property
 */
function setLocalStorage(key, value) {
  if (LOCAL_STORAGE_SUPPORT) {
    window.localStorage.setItem(key, value);
  } else {
    setCookie(key, value, 365);
  }
}

/**
 * remove a value in localStorage
 *
 * @param key - name of property
 */
function deleteLocalStorage(key) {
  if (LOCAL_STORAGE_SUPPORT) {
    window.localStorage.removeItem(key);
  } else {
    deleteCookie(key);
  }
}

/**
 * set a value in sessionStorage
 *
 * @param key - name of property
 * @param value - value of property
 */
function setSessionStorage(key, value) {
  if (SESSION_STORAGE_SUPPORT) {
    window.sessionStorage.setItem(key, value);
  } else {
    setCookie(key, value);
  }
}

/**
 * get a value from sessionStorage
 *
 * @param key - name of property to retrieve
 */
function getSessionStorage(key) {
  if (SESSION_STORAGE_SUPPORT) {
    return window.sessionStorage.getItem(key);
  }
  return getCookie(key);
}

/**
 * remove a value in sessionStorage
 *
 * @param key - name of property
 */
function deleteSessionStorage(key) {
  if (SESSION_STORAGE_SUPPORT) {
    window.sessionStorage.removeItem(key);
  } else {
    deleteCookie(key);
  }
}
function setAllStorage(key, value) {
  setCookie(key, value);
  setLocalStorage(key, value);
}
function getAllStorage(key) {
  var cookieValue = getCookie(key);
  var localStorageValue = getLocalStorage(key);
  if (cookieValue) {
    return cookieValue;
  }
  if (localStorageValue) {
    return localStorageValue;
  }
  return null;
}
function deleteAllStorage(key) {
  deleteLocalStorage(key);
  deleteCookie(key);
}
var _default = exports.default = {
  setCookie: setCookie,
  getCookie: getCookie,
  deleteCookie: deleteCookie,
  setLocalStorage: setLocalStorage,
  getLocalStorage: getLocalStorage,
  deleteLocalStorage: deleteLocalStorage,
  setSessionStorage: setSessionStorage,
  getSessionStorage: getSessionStorage,
  deleteSessionStorage: deleteSessionStorage,
  setAllStorage: setAllStorage,
  getAllStorage: getAllStorage,
  deleteAllStorage: deleteAllStorage
};